import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Colors, TextVariants } from "../../theme/enums";
export const ProductPriceColumn = ({ price, discountPrice }) => {
    return discountPrice ? (_jsxs(React.Fragment, { children: [_jsx("span", { sx: {
                    variant: `text.${TextVariants.label2}`,
                    display: "inline-block",
                    textDecoration: "line-through"
                }, children: price }), _jsx("span", { sx: {
                    variant: `text.${TextVariants.label2}`,
                    display: "inline-block",
                    color: `${Colors.red}.0`
                }, children: discountPrice })] })) : (_jsx("span", { sx: { variant: `text.${TextVariants.label2}`, color: Colors.muted }, children: price }));
};
export default ProductPriceColumn;
//# sourceMappingURL=ProductPriceColumn.js.map